import { Typography, Icon, Button, BUTTON_VARIANT } from '@sanlam-glacier/app-common/components';
import styles from './something-wrong-page.module.scss';
import { useErrorBoundary } from 'react-error-boundary';
import { Theme } from 'components/atoms/theme/Theme';

export const SomethingWentWrong = () => {
  const { resetBoundary } = useErrorBoundary();
  return (
    <div className={styles.pageErrorContainer}>
      <Icon icon='alert_warning' className={styles.errorPageIcon} />
      <Typography
        color={Typography.COLOR.PRIMARY}
        variant={Typography.VARIANT.H1}
        align={Typography.ALIGN.CENTER}
      >
        Something went wrong.
      </Typography>
      <Typography
        variant={Typography.VARIANT.B2}
        color={Typography.COLOR.TERTIARY}
        align={Typography.ALIGN.CENTER}
        className={styles.errorBodyText}
      >
        An error occurred while loading this page.
        <br />
        Please click the button below to refresh the page.
      </Typography>
      <Theme variant='secondary'>
        <Button variant={BUTTON_VARIANT.SECONDARY} onClick={resetBoundary}>
          Refresh
        </Button>
      </Theme>
    </div>
  );
};
